import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";
export const CollapseIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Collapse</title>;
    t1 = <path d="M14.293 17.1667L13.833 17.6257L10 13.7927L9.64648 14.1462L6.16602 17.6257L5.70703 17.1667L10 12.8738L14.293 17.1667ZM14.293 2.83374L10 7.12671L5.70703 2.83374L6.16699 2.37378L10 6.20679L13.833 2.37378L14.293 2.83374Z" stroke="currentColor" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};